import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	blogContainer: {
		background : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryBackgroundGrey,
		height     : "100%",
		width      : "100%"
	}
} ) );
